import React from "react";
import { useMemberAccess, memberstackLogout, LOGIN_URL } from "../lib/memberstack";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_pull-the-thread/artifacts/5kplwvsc_WEAVE-LOGO_2024.png";

export default function Header() {
  const access = useMemberAccess();
  const isMember =
    access.status === "member" || access.status === "unauthorised";

  async function handleSignOut() {
    await memberstackLogout();
    // Hard reload so all member-aware state resets cleanly
    window.location.reload();
  }

  return (
    <header
      className="relative z-10 px-6 md:px-12 py-5 md:py-6"
      data-testid="site-header"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-4">
        <a
          href="https://wearetheweave.co.uk"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3"
          data-testid="weave-home-link"
          aria-label="The Weave — home"
        >
          <img
            src={LOGO_URL}
            alt="The Weave"
            className="h-9 md:h-11 w-auto"
            loading="eager"
            decoding="async"
          />
          <span
            className="hidden sm:inline-flex items-center gap-2 pl-3 border-l-2 text-[#1a1a1a]"
            style={{ borderColor: "#3d2a14" }}
          >
            <span
              className="text-sm md:text-base font-semibold tracking-tight whitespace-nowrap"
              style={{ fontFamily: "Rubik, sans-serif" }}
              data-testid="product-wordmark"
            >
              Pull the Thread
            </span>
            <span
              className="hidden md:inline text-[10px] uppercase tracking-[0.2em] text-[#7a5816] px-2 py-0.5 rounded-full"
              style={{ backgroundColor: "#fae2b5" }}
            >
              Entertainment
            </span>
          </span>
        </a>

        <nav
          className="hidden md:flex items-center gap-7 text-sm text-[#3a3a3a]"
          aria-label="Primary"
        >
          <a href="#yarns" className="weave-link" data-testid="nav-yarns">
            The four yarns
          </a>
          <a href="#how-it-works" className="weave-link" data-testid="nav-how">
            How it works
          </a>
          <a href="#saved" className="weave-link" data-testid="nav-saved">
            Your loomboard
          </a>
        </nav>

        <div className="flex items-center gap-3">
          {isMember ? (
            <button
              type="button"
              onClick={handleSignOut}
              data-testid="header-signout"
              className="hidden sm:inline-flex items-center gap-1.5 text-sm text-[#3a3a3a]/80 hover:text-[#1a1a1a] weave-link"
            >
              Sign out
            </button>
          ) : (
            <a
              href={LOGIN_URL}
              data-testid="header-login"
              className="hidden sm:inline-flex items-center gap-1.5 text-sm text-[#3a3a3a]/80 hover:text-[#1a1a1a] weave-link"
            >
              Log in
            </a>
          )}

          <a
            href="https://www.wearetheweave.co.uk/blog"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-back-link"
            className="inline-flex items-center gap-2 px-4 md:px-5 py-2 md:py-2.5 rounded-full text-sm font-medium text-[#1a1a1a] border-2 transition-colors hover:bg-[#1a1a1a] hover:text-white"
            style={{ borderColor: "#1a1a1a" }}
          >
            <span className="hidden sm:inline">Want to read something new?</span>
            <span className="sm:hidden">Read</span>
            <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden>
              <path
                d="M2 7h10M8 3l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
      </div>
    </header>
  );
}
